import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '../../../../services/data/data.service'

const endPoint = '';
@Injectable({
  providedIn: 'root',
})
export class SelectService extends DataService {
  constructor(http: HttpClient) {
    super(endPoint, http);
  }

}
